<template>
  <section
    :class="$b({ underlayNavbar, maxHeight })"
    :style="styles"
  >
    <template v-if="$slots.media">
      <slot name="media" />
    </template>

    <BaseOverlay
      v-if="overlayGradient"
      :class="$b('overlay-gradient')"
      gradient
      gradient-height="30%"
    />

    <BaseOverlay
      :class="$b('overlay')"
      :overlay-opacity="overlayOpacity"
    />

    <BaseOverlay
      :class="$b('mobile-overlay')"
      :overlay-opacity="mobileOverlayOpacity"
    />

    <div
      v-if="$slots.centeredContent"
      :class="$b('centered-content')"
    >
      <div class="global-wrapper">
        <slot name="centeredContent" />
      </div>
    </div>

    <div
      v-if="$slots.content"
      class="BaseHero__content global-wrapper"
    >
      <slot name="content" />
    </div>

    <div
      v-if="$slots.badge"
      :class="$b('badge-wrapper')"
    >
      <slot name="badge" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'BaseHero',

  props: {
    overlayOpacity: { type: Number, default: 40 },
    mobileOverlayOpacity: { type: Number, default: 40 },
    overlayGradient: { type: Boolean, default: false },
    underlayNavbar: { type: Boolean, default: true },
    maxHeight: {
      type: [String, Number],
      default: 100,
      validator: value => [100, 90, 75, 50].includes(value) || value?.endsWith('px')
    }
  },

  computed: {
    overlayStyles () {
      return {
        opacity: this.overlayOpacity / 100
      }
    },
    styles () {
      if (this.maxHeight && typeof this.maxHeight === 'string') return {
        maxHeight: this.maxHeight
      }
      return {}
    }
  }
}
</script>

<style lang="postcss">
.BaseHero {
  @apply relative w-full overflow-visible;

  min-height: 400px;
  height: calc(90vh - 20px);

  &--underlay-navbar {
    top: calc(0px - var(--navbar-height));
  }

  &.promo-active {
    top: calc(0px - (var(--navbar-height) + var(--promo-banner-height)));
  }

  @screen md {
    min-height: 500px;
    height: calc(90vh - 20px);
  }

  &--max-height-90 {
    height: calc(90vh - theme('spacing.lg'));
    @screen md {
      height: calc(90vh - 20px);
    }
  }

  &--max-height-75 {
    height: calc(75vh - theme('spacing.lg'));
    @screen md {
      height: calc(75vh - 20px);
    }
  }

  &--max-height-50 {
    height: calc(50vh - theme('spacing.lg'));
    @screen md {
      height: calc(50vh - 20px);
    }
  }
}

.BaseHero__overlay,
.BaseHero__mobile-overlay {
  @apply absolute
    bg-black
    top-0
    left-0
    h-full
    w-full
    pointer-events-none;

  z-index: 5;
}

.BaseHero__overlay-gradient {
  @apply z-10;
}

.BaseHero__overlay {
  @apply hidden md:block;
}

.BaseHero__mobile-overlay {
  @apply hidden mdMax:block;
}

.BaseHero__centered-content {
  @apply absolute
    w-full
    text-white
    flex items-center;

  z-index: 10;
  top: 80px;
  width: 100%;
  height: calc(100% - 160px);

  > .global-wrapper:has(.HomepageHero__content .HomepageHero__structured-content) {
    @apply h-full;
  }
}

.BaseHero__content {
  @apply absolute
    w-full
    z-10
    text-white;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  @screen md {
    bottom: 58px;
  }
}

.BaseHero__badge-wrapper {
  @apply absolute
    bottom-0
    left-1/2
    transform
    -translate-x-1/2
    translate-y-1/2
    z-10;
}
</style>
